export const projectsGridConfig = {
  xsm: { cols: 1, gutterX: '20px', gutterY: '20px' },
  sm: { cols: 1, gutterX: '20px', gutterY: '20px' },
  md: { cols: 3, gutterX: '40px', gutterY: '40px' },
  lg: { cols: 3, gutterX: '50px', gutterY: '50px' },
  xl: { cols: 3, gutterX: '50px', gutterY: '50px' },
};
